<template lang='pug'>
v-app
  v-app-bar(
    app
    dark
    flat
  )
    v-btn.mr-2(
      to='/'
      text
    )
      | 🧠 ARK Invest Trades
    v-spacer
    TheUserIcon
  v-main
    Uid(
      v-slot='{ uid }'
    )
      router-view
</template>

<script>
import TheUserIcon from '@thomasphan/vue-components/src/components/TheUserIcon.vue';
import Uid from '@thomasphan/vue-components/src/components/Uid.vue';

export default
{
  name: 'App',
  components:
  {
    TheUserIcon,
    Uid,
  },
};
</script>
